module.exports = require("./el-CY.d.ts");